module.exports = __webpack_public_path__ + "static/media/roi2.b8958d08.png";